export default __webpack_public_path__ + "static/media/coming-soon-scene.137e7cd7.svg";